import React, { useState } from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import Layout from "../../layout/fullpage";

import { Media, MediaGroup, Image, Logo } from "../../components";
import { Spinner } from "react-bootstrap";
import image from "../../assets/images/bg-image/bg-image.jpg";
import image1 from "../../Images/bgimg1.png";
import { forgotPassword } from "../../services/AuthService";
import { toast } from "react-toastify";
function AuthResetPage() {
  const [email, setEmail] = useState();
  const [loading, setLoading] = useState(false);
  const sendlink = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await forgotPassword({ email: email });
      if (response) {
        toast.success("send link successfully");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    // <Layout title="Forgot Password" centered>
    <div className="d-flex align-items-center justify-content-center vh-100 vw-100">
      <div className="my-responsive-box">
        <Card className="h-100 w-100">
          {/* <Card className="w-100 overflow-hidden card-gutter-lg rounded-4 card-auth card-auth-mh"> */}
          <Row className="h-100 w-100 g-0 flex-lg-row-reverse">
            <Col lg="5" style={{ padding: "20px" }}>
              <Card.Body className="h-100 d-flex flex-column justify-content-center">
                <div className="nk-block-head text-center">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title mb-2">Reset password</h3>
                    <p className="small col-md-10 mx-auto">
                      If you forgot your password, don't worry! we’ll email you
                      instructions to reset your password.
                    </p>
                  </div>
                </div>
                <Form onSubmit={sendlink}>
                  <Row className="gy-3">
                    <Col className="col-12">
                      <Form.Group className="form-group">
                        <Form.Label htmlFor="email">Email</Form.Label>
                        <div className="form-control-wrap">
                          <Form.Control
                            type="email"
                            id="email"
                            placeholder="Enter email address"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col className="col-12">
                      <div className="d-grid">
                        <Button type="submit" disabled={loading || !email}>
                          {loading ? (
                            <>
                              <Spinner animation="border" size="sm" />
                              <span className="ms-1">Loading..</span>
                            </>
                          ) : (
                            "Send Reset Link"
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
                <div className="text-center mt-4">
                  <p className="small">
                    <Link to="/">Back to Login</Link>
                  </p>
                </div>
              </Card.Body>
            </Col>
            <div className="d-none d-lg-block col-lg-7">
              <Card.Body
                className="is-theme has-mask has-mask-1 h-100 d-flex flex-column justify-content-end"
                style={{
                  backgroundImage: `url(${image1})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
                centered
              >
                {/* <div className="brand-logo">
                  <Logo />
                </div> */}
                <div className="row">
                  <div className="col-sm-11">
                    <div className="mt-4">
                      {/* <div className="h1 title mb-3">
                        Welcome to <br /> InteliShuttle
                      </div>
                      <p>
                        Experience smarter Bus Pass management and seamless
                        operations to enhance productivity and efficiency.
                      </p> */}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </div>
          </Row>
          {/* </Card> */}
        </Card>
      </div>
    </div>
    // </Layout>
  );
}

export default AuthResetPage;
